module.exports = __webpack_public_path__ + "media/scene12_screen.96089715.mp3";